import { NavigationType, type Location } from "react-router-dom";

export type RouteKey = Pick<Location, "pathname" | "search" | "hash">;

/**
 * Decides whether a navigation from `prev` to `next` should land at the top of
 * the page. `navigationType` is React Router's PUSH (link click / navigate()),
 * REPLACE (navigate(..., { replace: true })) or POP (browser back/forward, and
 * the very first render). `prev` is null on the first render.
 */
export function shouldScrollToTop(
  prev: RouteKey | null,
  next: RouteKey,
  navigationType: NavigationType,
): boolean {
  // First render: the browser owns initial/reload scroll position.
  if (prev === null) return false;
  // Back/forward: let the browser restore where the user was.
  if (navigationType === NavigationType.Pop) return false;
  // In-page anchor: let the browser jump to the target element.
  if (next.hash && next.hash !== prev.hash) return false;
  // Only a new page lands at the top; search-only changes (e.g. ?tab=owners
  // on the dashboard) keep the user where they are.
  return next.pathname !== prev.pathname;
}

